"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.scheduleTemplateToDetailsBarInfo = exports.scheduleDTOtoDetailsBarInfo = exports.getScheduleTextWithIcon = exports.getStateTextWithIcon = exports.scheduleDetailsBar = exports.detailsBar = exports.scheduleDetailsBarText = exports.detailsBarText = void 0;
const adaptivecards_1 = require("adaptivecards");
const moment_1 = __importDefault(require("moment"));
const CardHelper_1 = require("../utils/CardHelper");
const DEFAULT_OPTIONS = {
    separator: true,
    spacing: adaptivecards_1.Spacing.Large,
    activeCardDateFormat: true,
    hideOwner: false,
    hideAnonymity: false,
    showStatus: true,
    showCompletions: true,
    showCloseDate: true,
    detailsJoinString: " | ",
    hideQuestionCount: false,
};
function detailsBarText(surveyInfo, options) {
    options = Object.assign(Object.assign({}, DEFAULT_OPTIONS), options);
    const isClosed = surveyInfo.state === "closed";
    const isPending = surveyInfo.state === "pending";
    const text = [];
    if (!options.hideOwner) {
        const owner = surveyInfo.owners[0];
        text.push(`Sender: ${owner.name}`);
    }
    if (options.showStatus) {
        text.push(isClosed ? "✴️ Closed" : isPending ? " 🅿️ Pending" : " ✳️ Open");
    }
    if (options.showCompletions && (surveyInfo.type === "survey" || surveyInfo.state === "closed")) {
        const responseCount = surveyInfo.responseCount;
        text.push(`✅ ${responseCount} completion${responseCount === 1 ? "" : "s"}`);
    }
    if (!options.hideQuestionCount && surveyInfo.type === "survey") {
        text.push(`💬 ${surveyInfo.questions.length} questions`);
    }
    if (!options.hideAnonymity) {
        switch (surveyInfo.anonymity) {
            case "anonymous":
                text.push("🔒 Anonymous");
                break;
            default:
                text.push("🔓 Non-Anonymous");
                break;
        }
    }
    if (surveyInfo.closeAt && options.showCloseDate) {
        const closeAt = options.activeCardDateFormat
            ? CardHelper_1.CardHelper.dateTimeReplacementString(surveyInfo.closeAt, "COMPACT")
            : (0, moment_1.default)(surveyInfo.closeAt).format("MMM Do LT");
        text.push(`🕘 ${isClosed ? "Closed" : "Closes"} ${closeAt}`);
    }
    return text.filter(e => e).join(options.detailsJoinString);
}
exports.detailsBarText = detailsBarText;
function scheduleDetailsBarText(scheduleInfo, options) {
    options = Object.assign(Object.assign({}, DEFAULT_OPTIONS), options);
    const text = [];
    if (!options.hideOwner) {
        text.push(`Owner: ${scheduleInfo.owners[0].name}`);
    }
    text.push(getStateTextWithIcon(scheduleInfo.state, !!scheduleInfo.lastSurveyId));
    const sendTime = options.activeCardDateFormat
        ? CardHelper_1.CardHelper.timeReplacementString(scheduleInfo.next)
        : (0, moment_1.default)(scheduleInfo.next).format("LT");
    if (scheduleInfo.frequency) {
        text.push(getScheduleTextWithIcon(scheduleInfo.frequency, sendTime));
    }
    return text.filter(e => e).join(" | ");
}
exports.scheduleDetailsBarText = scheduleDetailsBarText;
function detailsBar(survey, options) {
    options = Object.assign(Object.assign({}, DEFAULT_OPTIONS), options);
    return CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        separator: options.separator,
        spacing: options.spacing,
        isSubtle: true,
        wrap: true,
        text: detailsBarText(survey, options),
    });
}
exports.detailsBar = detailsBar;
function scheduleDetailsBar(scheduleInfo, options) {
    options = Object.assign(Object.assign({}, DEFAULT_OPTIONS), options);
    return CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        separator: options.separator,
        spacing: options.spacing,
        isSubtle: true,
        wrap: true,
        text: scheduleDetailsBarText(scheduleInfo, options),
    });
}
exports.scheduleDetailsBar = scheduleDetailsBar;
function getStateTextWithIcon(state, lastSurvey) {
    switch (state) {
        case "active":
            return lastSurvey === false ? " 🅿️ Pending" : " ✳️ Active";
        case "ended":
            return " ✴️ Ended";
        case "disabled":
            return " ⏸️ Disabled";
    }
    return "";
}
exports.getStateTextWithIcon = getStateTextWithIcon;
function getScheduleTextWithIcon(frequency, sendTime) {
    return `📅 ${frequency.charAt(0).toUpperCase()}${frequency.slice(1)} at ${sendTime}`;
}
exports.getScheduleTextWithIcon = getScheduleTextWithIcon;
function scheduleDTOtoDetailsBarInfo(schedule) {
    var _a, _b, _c;
    return {
        id: schedule.id,
        description: (_a = schedule.template) === null || _a === void 0 ? void 0 : _a.templateDescription,
        name: schedule.name,
        frequency: schedule.frequency,
        lastSurveyId: schedule.lastSurveyId,
        next: schedule.next,
        owners: schedule.owners,
        questions: ((_b = schedule.template) === null || _b === void 0 ? void 0 : _b.questions) || [],
        state: schedule.state,
        type: schedule.type,
        templateType: (_c = schedule.template) === null || _c === void 0 ? void 0 : _c.type,
    };
}
exports.scheduleDTOtoDetailsBarInfo = scheduleDTOtoDetailsBarInfo;
function scheduleTemplateToDetailsBarInfo(schedule, template, frequency) {
    return {
        id: schedule.id,
        description: frequency,
        name: schedule.name,
        frequency: frequency,
        lastSurveyId: schedule.lastSurveyId,
        next: schedule.next,
        owners: schedule.owners,
        questions: (template === null || template === void 0 ? void 0 : template.questions) || [],
        state: schedule.state,
        type: schedule.type,
        templateType: template === null || template === void 0 ? void 0 : template.type,
    };
}
exports.scheduleTemplateToDetailsBarInfo = scheduleTemplateToDetailsBarInfo;
//# sourceMappingURL=DetailsBar.js.map